var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Typography } from "@mui/material";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
export function TabLink(props) {
    var label = props.label, path = props.path, replaceLastPath = props.replaceLastPath, blackVersion = props.blackVersion, replaceLastPathOneDot = props.replaceLastPathOneDot;
    var _a = useState(false), isActive = _a[0], setIsActive = _a[1];
    var location = useLocation();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    useEffect(function () {
        setIsActive(location.pathname.split("/").indexOf(path) !== -1);
    }, [location]);
    return (_jsx(Button, __assign({ component: Link, viewTransition: true, id: "test-".concat(path), to: replaceLastPath ? "../".concat(path) : replaceLastPathOneDot ? "./".concat(path) : path, sx: {
            border: "1px solid rgba(65, 35, 130, 0.1)",
            borderRadius: {
                xs: "4px",
                sm: blackVersion ? "8px" : "20px",
            },
            height: {
                xs: "unset",
                sm: "56px",
            },
            width: "218px",
            flexGrow: 0,
            flexShrink: 1,
            flexBasis: "auto",
            textAlign: "center",
        }, disabled: isActive, variant: isActive ? "contained" : "outlined" }, { children: _jsx(Typography, __assign({ sx: {
                mx: "auto",
                typography: {
                    xs: isActive ? "gumbS" : "gumbSthin",
                    sm: isActive ? "podnaslovXS" : "podnaslovXS1",
                }
            } }, { children: getLocalizedString(label, currentLang) })) })));
}
